<ca-modal-container
    [modalTitle]="'APPLICATIONS.REQUEST_CUSTOMIZED_APPLICATION.TITLE' | translate"
    [description]="'APPLICATIONS.REQUEST_CUSTOMIZED_APPLICATION.SUB_TITLE' | translate"
    (dismiss)="dismiss()"
    data-uit="request-application-dialog"
>
    <form [formGroup]="formGroup" novalidate>
        <div class="border-bottom">
            <div class="d-flex flex-column-reverse">
                <input
                    id="email"
                    type="text"
                    class="form-control"
                    formControlName="email"
                    [placeholder]="'APPLICATIONS.REQUEST_CUSTOMIZED_APPLICATION.EMAIL_PLACEHOLDER' | translate"
                    required
                    data-uit="request-application-email"
                    [ngClass]="formGroup.get('email')?.errors && formGroup.get('email')?.dirty ? 'has-error' : ''"
                />
                <label class="" for="email">{{ 'GENERAL.COLUMN.EMAIL' | translate }}<span class="ms-1 red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('email')?.dirty && formGroup.get('email')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <small *ngIf="formGroup.get('email')?.dirty && formGroup.get('email')?.hasError('email')" class="invalid-feedback">
                {{ 'GENERAL.INVALID_EMAIL' | translate }}
            </small>
            <div class="d-flex flex-column-reverse form-group">
                <ca-quill-editor-wrapper
                    id="description"
                    name="description"
                    formControlName="description"
                    data-uit="request-application-description"
                    [placeholder]="'APPLICATIONS.REQUEST_CUSTOMIZED_APPLICATION.DESCRIPTION_PLACEHOLDER' | translate"
                    [required]="true"
                    [ngClass]="formGroup.get('description')?.dirty && formGroup.get('description')?.errors ? 'has-error' : ''"
                ></ca-quill-editor-wrapper>
                <label class="mt-4" for="description"
                    >{{ 'APPLICATIONS.REQUEST_CUSTOMIZED_APPLICATION.DESCRIPTION' | translate }}<span class="ms-1 red">*</span></label
                >
            </div>
            <small *ngIf="formGroup.get('description')?.dirty && formGroup.get('description')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <ca-files-upload-button
                [buttonText]="'APPLICATIONS.REQUEST_CUSTOMIZED_APPLICATION.UPLOAD_BTN_TEXT' | translate"
                [errorNotificationMode]="'notification'"
            ></ca-files-upload-button>
        </div>

        <div class="modal-buttons">
            <button
                type="button"
                class="btn btn-primary w-100 mt-4"
                [disabled]="!formGroup.valid || !uploadComponent?.fileUrls.length"
                (click)="submit()"
                data-uit="request-application-btn"
            >
                {{ 'APPLICATIONS.REQUEST_CUSTOMIZED_APPLICATION.SEND_REQUEST' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
